// extracted by mini-css-extract-plugin
export default {"main":"TextButton_main__Mc5MG","text":"TextButton_text__xcte9","spinner":"TextButton_spinner__AERxC","rotate":"TextButton_rotate__9o3f8"};